module.exports = __webpack_public_path__ + "img/gccc-storage.7e72ad6e.jpg";